<!--
* @description  参数1
* @fileName  index
* @author userName
* @date 2024-01-04 16:14:28
!-->
<template>
  <div id="index" :class="['checkPriceIndex', { 'p24': isClickQuery }]">
    <by-form
      ref="exp"
      :model="form"
      :rules="rules"
      submit
      style="display: flex; flex-wrap: wrap"
      :class="[{ 'checkPrice-form': isClickQuery }]"
    >
      <input-template
        style="width: 272px; margin: 4px; padding: 4px"
        :active-border="OriginIsFocus"
        :is-padding="false"
      >
        <ByFormItem
          ref="OriginByFormItem"
          prop="start"
          class="ByFormItem"
          :label-icon="true"
          label-icon-name="zuobiao1"
          :label-icon-size="16"
          label="Origin"
          @click.native.stop="focusShow('origin')"
        >

          <Origin
            ref="origin"
            placeholder="Where are you shipping from?"
            search-keys-type="Origin"
            width="260"
            @blur="()=>{
              $refs.OriginByFormItem.error = !OriginSuccess ? true :false
            }"
            @checkprice="checkprice"
            @getFocusStatus="(val) => {
              OriginIsFocus = val;
            }
            "
            @next="originNext"
            @typeChange="originTypeChange"
          />
        </ByFormItem>
      </input-template>

      <input-template
        style="width: 272px; margin: 4px; padding: 4px"
        :active-border="DestinationIsFocus"
        :is-padding="false"
      >
        <ByFormItem
          ref="DestinationByFormItem"
          prop="start"
          class="ByFormItem Destination"
          :label-icon="true"
          label-icon-name="zuobiao1"
          :label-icon-size="16"
          label="Destination"
          @click.native.stop="focusShow('Destination')"
        >
          <Destination
            ref="Destination"
            placeholder="Where are you shipping to?"
            search-keys-type="Destination"
            width="260"
            @blur="()=>{
              $refs.DestinationByFormItem.error = !DestinationSuccess ? true :false
            }"
            @checkprice="checkprice"
            @getFocusStatus="(val) => {
              DestinationIsFocus = val;
            }
            "
            @next="destNext"
            @typeChange="destTypeChange"
          />
        </ByFormItem>
      </input-template>

      <input-template
        style="width: 272px; margin: 4px; padding: 4px"
        :active-border="LoadIsFocus"
        :is-padding="false"
      >
        <ByFormItem
          ref="LoadByFormItem"
          prop="Load"
          class="ByFormItem Load"
          :label-icon="true"
          label-icon-name="zuobiao1"
          :label-icon-size="16"
          label="Load"
          @click.native.stop="focusShow('Load')"
        >
          <Load
            ref="Load"
            placeholder="Where are you shipping?"
            search-keys-type="Load"
            width="260"
            @blur="()=>{
              $refs.LoadByFormItem.error = !LoadSuccess ? true :false
            }"
            @getFocusStatus="(val) => {
              LoadIsFocus = val;
            }
            "
            @next="loadNext"
          />
        </ByFormItem>
      </input-template>
      <input-template
        style="width: 272px; margin: 4px; padding: 4px"
        :active-border="GoodsFocus"
        :is-padding="false"
      >
        <ByFormItem
          ref="GoodsByFormItem"
          prop="Goods"
          class="ByFormItem Goods"
          :label-icon="true"
          label-icon-name="zuobiao1"
          :label-icon-size="16"
          label="Goods"
          @click.native.stop="focusShow('Goods')"
        >
          <Goods
            ref="Goods"
            placeholder="Tell us about your goods"
            search-keys-type="Goods"
            width="260"
            :dest-type="inputData.DestinationType"
            @blur="()=>{
              $refs.GoodsByFormItem.error = !GoodsSuccess ? true :false
            }"
            @getFocusStatus="(val) => {
              GoodsFocus = val;
            }
            "
            @next="goodsNext"
          />
        </ByFormItem>
      </input-template>
      <button
        v-if="!isClickQuery"
        type="button"
        :class="{ 'complete': OriginSuccess && DestinationSuccess && LoadSuccess && GoodsSuccess,
                  'no-drop':!(OriginSuccess && DestinationSuccess && LoadSuccess && GoodsSuccess) }"
        class="by-check-button"
        :disabled="!(OriginSuccess && DestinationSuccess && LoadSuccess && GoodsSuccess)"
        @click="queryPrice"
      ><i
        class="el-icon-search"
      /></button>
    </by-form>
    <div v-if="isClickQuery" class="expand-price">
      <div class="e-p-title">Recommended Services</div>
      <div class="e-p-tip">
        <span>We've selected all the services you need to ship your goods from a Factory/Warehouse to a Business
          address.
          Please check and confirm before getting your results.</span>
      </div>
      <div class="switch-main">
        <div class="switch-card">
          <div class="switch-card-l">
            <div v-show="inputData.OriginType==1||inputData.DestinationType==1" class="switch-l">
              <p>Port Charges</p>
              <div v-if="inputData.OriginType==1">
                <el-switch
                  v-model="inputData.IsOriginCharges"
                  active-color="#13ce66"
                  inactive-color="#777777"
                  :active-text="inputData.IsOriginCharges ? 'Yes - Add origin charges' : 'No - My delivery agent will cover any supplier charges'"
                />
              </div>
              <div v-if="inputData.DestinationType==1">
                <el-switch
                  v-model="inputData.IsDestinationCharges"
                  active-color="#13ce66"
                  inactive-color="#777777"
                  :active-text="inputData.IsDestinationCharges ? 'Yes - Add destination charges' : 'No - My supplier will cover delivery agent charges'"
                />
              </div>
            </div>
            <div
              v-if="inputData.OriginType==2||inputData.OriginType==3||inputData.DestinationType==2||inputData.DestinationType==4"
              class="switch-l"
            >
              <p>Liftgate</p>
              <div v-if="inputData.OriginType==2||inputData.OriginType==3">
                <el-switch
                  v-model="inputData.IsLiftgatePickup"
                  active-color="#13ce66"
                  inactive-color="#777777"
                  :active-text="inputData.IsLiftgatePickup ? 'Yes - Add a liftgate at pickup' : 'No - There’s a loading dock at pickup'"
                />
              </div>
              <div v-if="inputData.DestinationType==2||inputData.DestinationType==4">
                <el-switch
                  v-model="inputData.IsLiftgateDelivery"
                  active-color="#13ce66"
                  inactive-color="#777777"
                  :active-text="inputData.IsLiftgateDelivery ? 'Yes - Add a liftgate at delivery' : 'No - There’s a loading dock at delivery'"
                />
              </div>
            </div>
            <div class="switch-l">
              <p>Insurance</p>
              <div>
                <el-switch
                  v-model="inputData.IsInsurance"
                  active-color="#13ce66"
                  inactive-color="#777777"
                  :active-text="inputData.IsInsurance ? 'Yes - (covers the combined value of goods and initial freight costs up to $500k)' : 'No - I’ve either got insurance or take full responsibility for any lost or damaged cargo'"
                />
              </div>

            </div>
          </div>
          <div class="switch-card-r">
            <div class="switch-l">
              <p>Customs brokerage and bond</p>
              <div>
                <el-switch
                  v-model="inputData.IsCustomsBrokerage"
                  active-color="#13ce66"
                  inactive-color="#777777"
                  :active-text="inputData.IsCustomsBrokerage ? 'Yes - I need customs brokerage' : 'No - I have a customs broker'"
                />
              </div>
              <div v-if="inputData.IsCustomsBrokerage">
                <el-switch
                  v-model="inputData.IsBond"
                  active-color="#13ce66"
                  inactive-color="#777777"
                  :active-text="inputData.IsBond ? 'Yes - I need a customs bond' : 'No - I have a customs bond'"
                />
              </div>
            </div>

            <div v-if="inputData.IsBond&&inputData.IsCustomsBrokerage" class="switch-l flex">
              <div :class="['switch-card-left', { 'active-class': isSingleEntry }]">
                <div class="first-line">
                  <div class="el-checkbox-style">
                    <el-checkbox v-model="isSingleEntry" @change="isSingleEntryChange">Single entry
                      bond</el-checkbox>
                  </div>
                  <div><span>from</span><span>${{ singleBondFee }} -
                    ${{ singleBondFee+sysConfig.ISFBondFee }}</span></div>
                </div>
                <div class="two-line">
                  <span>Single-use bond. Costs {{ sysConfig.singleBondFee*100 }}% of goods’ value,
                    plus duties above $10k. Ocean shipments need ISF bond
                    (${{ sysConfig.ISFBondFee }}). Final cost may be subject to additional
                    fees.</span>
                </div>
              </div>
              <div :class="['switch-card-left', { 'active-class': isAnnual }]">
                <div class="first-line">
                  <div class="el-checkbox-style">
                    <el-checkbox v-model="isAnnual" @change="isAnnualChange">Annual
                      bond</el-checkbox>
                  </div>
                  <div><span /><span> ${{ sysConfig.yearBondFee }}</span></div>
                </div>
                <div class="two-line">
                  <span>Valid for multiple imports within 12 months and can be used across multiple
                    providers. No additional
                    bond costs.</span>
                </div>
              </div>

            </div>

            <div class="switch-l">
              <p class="mb45" />
              <div>
                <el-switch
                  v-model="inputData.IsKnown"
                  active-color="#13ce66"
                  inactive-color="#777777"
                  :active-text="inputData.IsKnown ? 'I am verified with the TSA as a known shipper' : 'I am not a known shipper'"
                />
                <div class="wenhao-tip">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="Known Shippers have been vetted by the TSA, and can book air rates for both passenger and cargo planes. If you book a passenger rate and your status as a Known Shipper is not validated, your shipment will be canceled."
                    popper-class="tooltip-popper-class"
                    placement="top"
                  >
                    <div>?</div>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="expand-price-button">
        <el-button v-loading.fullscreen.lock="fullscreenLoading" @click="getResults">Confirm Services & Get Results</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  GetSysConfig
} from '/src/api/base.js'
import {
  QueryPrice
} from '/src/api/checkPrice.js'
import {
  getCookie
} from '@/utils/cookiejs'
import Origin from './origin.vue'
import Destination from './destination.vue'
import Load from './load.vue'
import Goods from './goods.vue'
import InputTemplate from '../byForm/InputTemplate.vue'
import ByFormItem from '../byForm/ByFormItem.vue'
import ByForm from '../byForm/ByForm.vue'
import { Loading } from 'element-ui'
export default {
  name: 'Index',
  components: {
    // 组件的引用
    InputTemplate,
    ByFormItem,
    Origin,
    Destination,
    ByForm,
    Load,
    Goods
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      OriginIsFocus: false, // 起始地目的地输入框高亮
      DestinationIsFocus: false,
      LoadIsFocus: false,
      GoodsFocus: false,
      form: {},
      rules: {},
      OriginSuccess: false, // orgin信息填写成功
      DestinationSuccess: false, // Destination信息填写成功
      LoadSuccess: false, // Load信息填写成功
      GoodsSuccess: false, // Goods信息填写成功
      isClickQuery: false, // 是否点击查价按钮
      isSingleEntry: true,
      isAnnual: false,
      loadInfo: {},
      originInfo: {},
      destInfo: {},
      goodsInfo: {},
      inputData: {
        OriginType: '',
        OriginCountryId: '',
        OriginCountryCode: '',
        OriginCityId: '',
        OriginAddressCode: '',
        OriginAirportId: '',
        OriginPortId: '',
        OriginPortType: '',
        OriginZipCode: '',
        DestinationType: 4,
        DestinationCountryId: '',
        DestinationCountryCode: '',
        DestinationCityId: '',
        DestinationAddressCode: '',
        DestinationZipCode: '',
        DestinationAirportId: '',
        DestinationPortId: '',
        DestinationWarehouseId: '',
        DestinationPortType: '',
        FbaWarehouseCode: '',
        TotalQuantity: '',
        TotalWeight: '',
        TotalVolume: '',
        GoodsValue: '',
        GoodsName: '',
        GoodsReadyTime: '',
        GoodsType: '',
        IsOriginCharges: true,
        IsDestinationCharges: true,
        IsLiftgatePickup: undefined,
        IsLiftgateDelivery: undefined,
        IsInsurance: true,
        IsCustomsBrokerage: true,
        IsBond: true,
        BondType: true,
        IsKnown: false,
        SortType: 0
      },
      results: [],
      isEdit: false,
      isQuick: false,
      step: undefined,
      sysConfig: {},
      singleBondFee: undefined,
      fullscreenLoading: false
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
    this.initSysConfig()
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    originTypeChange(type) {
      this.inputData.OriginType = type
    },
    destTypeChange(type) {
      this.inputData.DestinationType = type
    },
    initSysConfig() {
      GetSysConfig().then(res => {
        if (res.code === 200) {
          this.sysConfig = res.data
        }
      })
    },
    init(step) {
      this.step = step
      if (step === 1) {
        this.isClickQuery = true
      } else {
        this.isClickQuery = false
      }
    },
    isAnnualChange(val) {
      this.isSingleEntry = false
      if (!val) {
        this.isAnnual = true
      }
    },
    isSingleEntryChange(val) {
      this.isAnnual = false
      if (!val) {
        this.isSingleEntry = true
      }
    },
    originNext(data) {
      this.originInfo = data
      this.$refs.OriginByFormItem.success = true
      this.$refs.OriginByFormItem.error = false
      this.OriginSuccess = true
      if (!this.isClickQuery && !this.isEdit && !this.isQuick) {
        this.$refs.Destination.focusInput()
      }
    },
    destNext(data) {
      this.destInfo = data
      this.$refs.DestinationByFormItem.success = true
      this.$refs.DestinationByFormItem.error = false
      this.DestinationSuccess = true
      if (!this.isClickQuery && !this.isEdit && !this.isQuick) {
        this.$refs.Load.focusInput()
      }
    },
    loadNext(loadInfo) {
      this.loadInfo = loadInfo
      this.$refs.LoadByFormItem.success = true
      this.$refs.LoadByFormItem.error = false
      this.LoadSuccess = true
      if (!this.isClickQuery && !this.isEdit && !this.isQuick) {
        this.$refs.Goods.focusInput()
      }
    },
    goodsNext(data) {
      this.goodsInfo = data
      this.$refs.GoodsByFormItem.success = true
      this.$refs.GoodsByFormItem.error = false
      this.GoodsSuccess = true
    },
    // 方法
    // 组件点击事件
    focusShow(ref) {
      this.$refs[ref].focusInput()
      const list = ['origin', 'Destination', 'Load', 'Goods']
      list.forEach(item => {
        console.log(item)
        if (item != ref) {
          this.$refs[item].closePanel()
        }
      })
    },
    queryPrice() {
      if (this.OriginSuccess && this.DestinationSuccess && this.LoadSuccess && this.GoodsSuccess) {
        this.inputData.OriginType = this.originInfo.Type
        this.inputData.OriginCountryId = this.originInfo.Country
        this.inputData.OriginCountryCode = this.originInfo.CountryCode
        this.inputData.OriginAddressCode = this.originInfo.AddressCode
        if (this.originInfo.Type === 1) {
          // portType 1 港口 2 机场
          if (this.originInfo.PortType === 1) {
            this.inputData.OriginPortId = this.originInfo.Address
          } else {
            this.inputData.OriginAirportId = this.originInfo.Address
          }
          this.inputData.OriginPortType = this.originInfo.PortType
        } else {
          this.inputData.OriginCityId = this.originInfo.Address
          this.inputData.OriginZipCode = this.originInfo.ZipCode
        }
        this.inputData.DestinationType = this.destInfo.Type
        this.inputData.DestinationCountryId = this.destInfo.Country
        this.inputData.DestinationCountryCode = this.destInfo.CountryCode
        this.inputData.DestinationAddressCode = this.destInfo.AddressCode
        if (this.destInfo.Type === 1) {
          if (this.destInfo.PortType === 1) {
            this.inputData.DestinationPortId = this.destInfo.Address
          } else {
            this.inputData.DestinationAirportId = this.destInfo.Address
          }
          this.inputData.OriginPortType = this.originInfo.PortType
        } else if (this.destInfo.Type === 3) {
          this.inputData.FbaWarehouseCode = this.destInfo.Address
        } else {
          this.inputData.DestinationCityId = this.destInfo.Address
          this.inputData.DestinationZipCode = this.destInfo.ZipCode
        }
        this.inputData.TotalQuantity = this.loadInfo.quantity
        this.inputData.TotalWeight = this.loadInfo.weight
        this.inputData.TotalVolume = this.loadInfo.volume
        this.inputData.GoodsValue = this.goodsInfo.goodsValue
        this.inputData.GoodsName = this.goodsInfo.goodsName
        this.inputData.GoodsType = this.goodsInfo.goodsType
        this.inputData.GoodsReadyType = this.goodsInfo.goodsReadyTime
        var goodsReady = new Date()
        if (this.goodsInfo.goodsReadyTime == 1) {
          goodsReady.setDate(goodsReady.getDate() + 1)
        } else if (this.goodsInfo.goodsReadyTime == 2) {
          goodsReady.setDate(goodsReady.getDate() + 1)
        } else if (this.goodsInfo.goodsReadyTime == 3) {
          goodsReady.setDate(goodsReady.getDate() + 15)
        }
        this.inputData.GoodsReadyTime = goodsReady
      }
	  console.log(this.inputData)
	  if (this.inputData.IsLiftgatePickup == undefined) {
		  if (this.inputData.OriginType == 3) {
		    this.inputData.IsLiftgatePickup = true
		  } else {
		    this.inputData.IsLiftgatePickup = false
		  }
	  }
      if (this.inputData.IsLiftgateDelivery == undefined) {
		  if (this.inputData.DestinationType == 4) {
		    this.inputData.IsLiftgateDelivery = true
		  } else {
		    this.inputData.IsLiftgateDelivery = false
		  }
	  }

      this.isClickQuery = true
      this.singleBondFee = this.inputData.GoodsValue * this.sysConfig.singleBondFee
      if (this.singleBondFee < this.sysConfig.singleBondFeeMin) {
        this.singleBondFee = this.sysConfig.singleBondFeeMin
      }
      this.$emit('step', true, 1) // 显示true进度条  1：第二条
    },
    getResults() {
      var cookie = getCookie('token')
      if (!cookie) {
        this.$store.commit('user/DIALOG_VISIBLE', true)
        return
      }
      if (this.inputData.IsBond) {
        if (this.isAnnual) {
          this.inputData.BondType = 2
        } else {
          this.inputData.BondType = 1
        }
      } else {
        this.inputData.BondType = 0
      }
	  if (!Array.isArray(this.inputData.GoodsType)) {
	    this.inputData.GoodsType = [this.inputData.GoodsType]
	  }
    this.fullscreenLoading=true;
      QueryPrice(this.inputData).then(res => {
        if (res.code === 200) {
          this.isClickQuery = false
          this.fullscreenLoading=false;
          this.isEdit = true
          localStorage.setItem('queryInput', JSON.stringify(this.inputData))
          localStorage.setItem('queryResult', JSON.stringify(res.data))
          this.$emit('step', true, 2, res.data, this.inputData) // 显示true进度条  1：第二条
        }
      })
    },
    checkprice(inputdata, isOpen = true) {
      this.isQuick = true
      var originData = {
        Type: inputdata.OriginType,
        Country: inputdata.OriginCountryId
      }
      if (inputdata.OriginType === 1) {
        if (inputdata.OriginPortId) {
          originData.Address = inputdata.OriginPortId
        } else {
          originData.Address = inputdata.OriginAirportId
        }
      } else {
        originData.Address = inputdata.OriginCityId
        originData.ZipCode = inputdata.OriginZipCode
      }
      this.$refs.origin.init(originData)

      var destData = {
        Type: inputdata.DestinationType,
        Country: inputdata.DestinationCountryId
      }
      this.inputData.DestinationType = inputdata.DestinationType
      if (inputdata.DestinationType === 1) {
        if (inputdata.DestinationPortId) {
          destData.Address = inputdata.DestinationPortId
        } else {
          destData.Address = inputdata.DestinationAirportId
        }
      } else if (inputdata.DestinationType === 3) {
        destData.Address = inputdata.FbaWarehouseCode
      } else {
        destData.Address = inputdata.DestinationCityId
        destData.ZipCode = inputdata.DestinationZipCode
      }
      this.$refs.Destination.init(destData)
      var loadData = {
        quantity: inputdata.TotalQuantity,
        volume: inputdata.TotalVolume,
        weight: inputdata.TotalWeight,
        volumeUnit: 'CBM',
        weightUnit: 'KG'
      }
      this.$refs.Load.init(loadData, 1)
      if (isOpen) {
        this.focusShow('Goods')
      }
    }

  }
}
</script>
<style scoped lang='scss'>
	@font-face {
		font-family: "D-DINExp";
		src: url("../../../assets/font/D-DINExp.otf") format('opentype');
	}

	.p24 {
		padding: 24px;
	}

	.checkPriceIndex {
		width: 1200px;
		min-height: 80px;
		background: #ffffff;
		border-radius: 8px;

		.checkPrice-form {
			border-radius: 8px;
			border: 1px solid #DDDDDD;
		}

		.ByFormItem {
			padding: 4px;
			height: 72px;

			::v-deep .form-item__label {
				font-size: 13px;
				font-family: D-DINExp, D-DINExp;
				font-weight: bold;
				color: #333333;
			}
		}

		.Destination {
			::v-deep .by-panel {
				left: 283px;
			}
		}

		.Load {
			::v-deep .by-panel {
				width: 724px;
				left: 474px;
			}
		}

		.Goods {
			::v-deep .by-panel {
				width: 800px;
				left: 398px;
			}
		}

		.by-check-button {
			width: 48px;
			height: 48px;
			background: #F5B492;
			border-radius: 8px;
			color: #FFFFFF;
			border: 0;
			margin: 15px;
			font-size: 23px;
		}

		.complete {
			background: #E95506;
		}

		.no-drop {
			cursor: no-drop;
		}

		.expand-price {
			text-align: left;

			.e-p-title {
				font-size: 16px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 600;
				color: #333333;
				height: 56px;
				line-height: 56px;
			}

			.e-p-tip {
				width: 1168px;
				height: 40px;
				background: rgba(233, 85, 6, 0.04);
				border-radius: 4px;
				font-size: 13px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				color: #E95506;
				line-height: 40px;
				padding: 0 8px;
			}

			.switch-main {
				.switch-card {
					display: flex;
					align-items: stretch; // 垂直方向，子元素左右等高
					flex-flow: row wrap; // 以行排列 并且允许换行
					align-content: flex-start;

					// .switch-l:nth-child(2n+1) {
					.switch-card-l {
						width: 40%;
					}

					//.switch-l:nth-child(2n) {
					.switch-card-r {
						width: 60%;
					}

					.flex {
						display: flex;
					}

					.switch-l {

						::v-deep .el-switch__label,
						.is-active {
							font-size: 14px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							color: #333333;
						}

						.mb45 {
							margin-bottom: 45px;
						}

						p {
							font-size: 14px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 500;
							color: #333333;
						}

						div {
							margin: 5px 0;
						}

						.active-class {
							background: rgba(2, 127, 252, 0.04) !important;
							border: 1px solid #027FFC !important;
						}

						.wenhao-tip {
							display: inline-block;
							margin-left: 5px;
							font-size: 12px;
							width: 12px;
							height: 12px;
							border: 1px solid #333333;
							color: #333333;
							border-radius: 50%;

							&:hover {
								border: 1px solid #027FFC;
								color: #027FFC;
							}

							div {
								margin: 0 !important;
								text-align: center !important;
							}
						}

						.switch-card-left {
							width: 297px;
							height: 106px;
							background: rgba(221, 221, 221, 0.24);
							border-radius: 8px;
							border: 1px solid rgba(170, 170, 170, 0);
							padding: 16px;
							margin-right: 16px;

							.first-line {
								display: flex;
								justify-content: space-between;
								margin: 0px;

								.el-checkbox-style {
									margin: 0px 0px;
									display: flex;
								}

								.el-checkbox-style ::v-deep .el-checkbox {
									.el-checkbox__inner {
										width: 16px;
										height: 16px;

										&::after {
											height: 8px;
											left: 4.5px;
										}
									}

									.el-checkbox__label {
										font-size: 14px;
										font-family: PingFangSC, PingFang SC;
										font-weight: 500;
										color: #333333;
										line-height: 22px;
									}
								}

								.el-checkbox-style ::v-deep .is-checked {
									.el-checkbox__inner {
										border-color: #027FFC;
										background: #027FFC;
									}
								}

								div:nth-of-type(2) {
									margin: 0px;
									font-size: 16px;
									font-family: D-DINExp;
									font-weight: normal;

									span:nth-of-type(1) {
										color: #AAAAAA;
									}

									span:nth-of-type(2) {
										color: #EF0A0A;
									}
								}
							}

							.two-line {
								font-size: 13px;
								font-family: PingFangSC, PingFang SC;
								font-weight: 400;
								color: #333333;
								margin-top: 16px;
							}
						}
					}
				}
			}

			.expand-price-button {
				text-align: center;

				button {
					width: 288px;
					height: 40px;
					background: #E95506;
					border-radius: 8px;
					border: 1px solid #E95506;
					font-size: 16px;
					font-family: D-DINExp, D-DINExp;
					font-weight: bold;
					color: #FFFFFF;
					cursor: pointer;
					margin: 40px 0;

				}

			}
		}
	}
</style>
